import { i8nEvent } from "../../share/i18n/event"

const i18nStorageKey = "$MAX_I18N_LANG"

let _supportList: string[] = []

/**
 * 2025-07-30逻辑
 * 当前语言选择的优先级逻辑
 * 用户手动选择（setCurrentLang）> 跟随系统 > 默认语言
 */
let _i18nlang: string

export const i18n = {
  init(lang: string, defaultLang: string) {
    /**
     * 如果用户手动选择语言， 需要兼容一下，缓存中语言是否支持。不支持则需要用默认语言重置
     */
    if (localStorage.getItem(i18nStorageKey)) {
      if (!_supportList.includes(lang)) {
        i18n.setCurrentLang(defaultLang)
      }
    }
    _i18nlang = lang
  },
  setLangList(list) {
    _supportList = list
  },
  getLangList() {
    return _supportList
  },
  setCurrentLang(lang) {
    if (i18n.getCurrentLang() === lang) return false
    let langList = i18n.getLangList() || []
    langList = [...langList, "system"]
    if (!langList.includes(lang)) {
      return false
    }
    localStorage.setItem(i18nStorageKey, lang)
    i8nEvent.emit(lang)
    return true
  },
  getCurrentLang() {
    return localStorage.getItem(i18nStorageKey) || _i18nlang
  },
  onChange(fn) {
    i8nEvent.addListener(fn)
  },
} as I18nDSL & {
  init(lang: string, defaultLang?: string): void
  setLangList(list: string[]): void
}
